import React from 'react';

function Footer({ isMobile, setCurrentPage }) {
  return (
    <footer className="bg-gradient-to-r from-gray-900 to-gray-800 text-white py-12">
      <div className="container mx-auto px-4">
        <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-3'} gap-8`}>
          <div>
            <h3 className="text-2xl font-bold mb-3">Sir Henry Butchery</h3>
            <p className="text-yellow-400 font-semibold mb-2">Quality You Can Taste</p>
            <p className="text-gray-300">Providing premium pork cuts in Chitungwiza</p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold text-yellow-400 mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {['Home', 'Shop'].map((item) => (
                <li key={item}>
                  <button 
                    className="text-gray-300 hover:text-yellow-400 transition-colors"
                     onClick={() => setCurrentPage(item.toLowerCase())}
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold text-yellow-400 mb-4">Contact Info</h4>
            <p className="text-gray-300">+263 783 90 7172</p>
            <p className="text-gray-300">sirhenrybutchery@gmail.com</p>
            <p className="text-gray-300">Zvido Business Centre, Chitungwiza</p>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            &copy; {new Date().getFullYear()} Sir Henry Butchery. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;